const NoticeRecord = () => import('@/views/main/noticeRecord/index.vue')
export default {
  path: '/main/noticeRecord',
  name: 'NoticeRecord',
  component: NoticeRecord,
  children: []
}
